import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'

const MATE = `${shop_url}/shop/app/company/employeeInfo`

/* 获取客户 */
export const getCustomerData = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/customer/${data.companyId}/${data.page}/${data.size}`
  })
}
/* 新增客户 */
export const addCustomer = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/customer`,
    method: 'post',
    data
  })
}
/* 搜索员工 */
export const serMatesByCustomer = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/customer/${data.companyId}/${data.page}/${data.size}?keyword=${data.keyword}`
  })
}
/* 删除客户 */
export const delCustomer = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/customer/${data.companyId}/${data.userId}`,
    method: 'delete'
  })
}
/* 修改客户 */
export const editCustomer = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/customer`,
    method: 'put',
    data
  })
}
// 获取客户标签
export const getMateTag = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/tag/${data.companyId}`,
    method: 'get'
  })
}
// 添加客户标签
export const addMateTag = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/tag`,
    method: 'post',
    data
  })
}
// 删除客户标签
export const deleteMateTag = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/tag?id=${data}`,
    method: 'delete'
  })
}
/* 获取公司员工姓名 */
export const getMateNameByPhone = (data) => {
  const { phone, companyId } = data
  return fetch({
    url: `${shop_url}/shop/app/company/employee?phone=${phone}&companyId=${companyId}`,
    method: 'get'
  })
}
